<template>
    <div>
        <h3 id="codeclient" v-if="noEmpty(client.code)"> code client : {{ client.code }} </h3>
        <h1 class='component_title'>{{ client.name }} : Liste des intervenants </h1>
        <div id="userTab" class="pl-list">
            <div class="header">
                <div class="header_line">
                    <div id="header_col1" class="header_col col1">Nom</div>
                    <div id="header_col2" class="header_col col2">Prénom</div>
                    <div id="header_col3" class="header_col col3">Courriel</div>
                    <div id="header_col4" class="header_col col4">Rôle</div>
                    <div id="header_col5" class="header_col col5">Notes</div>
                    <div id="header_col6" class="header_col col6"></div>
                </div>
            </div>
        
            <div class="content" ref="usersBox">
                <userLine v-for="(user) in users" :key='user.id' :userObj='user'   ></userLine>

                <div class="dummyline" :style="{'height': dummyUserHeight+'px'}">
                    <div class="col col1">&nbsp;</div>
                    <div class="col col2">&nbsp;</div>
                    <div class="col col3">&nbsp;</div>
                    <div class="col col4">&nbsp;</div>
                </div>
            </div>
            <div id="usersFooter" class="footer">
                <div class="buttons">
                    <button id="btn_addUser" type="button" class="liste_btn boutonTableau" title="Créer un intervenant" @click="clickAddUser()">Créer un intervenant</button>
                </div>
            </div>
        </div>
        <br/>
        <div >
            <hr/>
            <h1 class='component_title'>{{ client.name }} : Liste des domaines </h1>

            <div id="hostTab" class="pl-list">
                <div class="header">
                    <div class="header_line">
                        <div id="header_col1" class="header_col col1">Domaines</div>
                        <div id="header_col2" class="header_col col2">En cours d'utilisation</div>
                        <div id="header_col3" class="header_col col3">Configurer les autorisations</div>
                    </div>
                </div>
            
                <div class="content" ref="hostsBox">
                    <hostLine v-for="(host) in hosts" :key='host.id' :hostObj='host'   ></hostLine>

                    <div v-if="isSuperAdmin()" class="dummyline" :style="{'height': dummyHostHeight+'px'}">
                        <div class="col col1">&nbsp;</div>
                        <div class="col col2">&nbsp;</div>
                    </div>
                </div>
                <div  id="hostFooter" class="footer">
                    <div class="buttons" v-if="isSuperAdmin()">
                        <button id="btn_addHost" type="button" class="liste_btn boutonTableau" title="Ajouter" @click="clickAddHost()">Ajouter</button>
                    </div>
                </div>
            </div>
        </div>
        <br/>
        <div v-if="isSuperAdmin()">
            <hr/>
            <settingTab  mode="liste" :client="client" :settings="settings"></settingTab>
            <br/>
        </div>
        
    </div>
</template>

<script>
    import FctUtils from '@/components/FctUtils';
    import UserLine from '@/components/UserLine';
    import HostLine from '@/components/HostLine';
    import SelectDicoSetting from './SelectDicoSetting';
    import axios from 'axios'
    import { diagonalbackURL, defaultConfig } from "../constantes";
    import { RoleEnum } from '../classes/enums';

    export default {
        name: "Client",
        components:{
            "userLine":UserLine,
            "hostLine":HostLine,
            "settingTab":SelectDicoSetting,
        },
        mixins: [FctUtils],
        props :{
            // pas de type
            // Si via lien =>  number
            // Si acces direct via url => string
            clientId : {  } 
        },
        data(){
            return {
                client:{},
                users:{},
                hosts:{},
                settings:{},
                dummyUserHeight:25,
                dummyHostHeight:25
            }
        },
        mounted() {
            // Permet au SUPERADMIN de changer de client
            this.$store.dispatch('chooseClient', this.clientId);

            // Evenement relatif a la creation/modification/suppresion d'un intervenant
            //
            this.emitter.on('createUser', userdata => {
                this.createUser(userdata);
            });
            this.emitter.on('editUser', userdata => {
                this.editUser(userdata);
            });
            this.emitter.on('removeUser', userdata => {
                this.removeUser(userdata);
            });

            // Evenement relatif a la creation/modification/suppresion d'un domaine
            //
            this.emitter.on('createHost', hostdata => {
                this.createHost(hostdata);
            });
            this.emitter.on('editHost', hostdata => {
                this.editHost(hostdata);
            });
            this.emitter.on('removeHost', hostdata => {
                this.removeHost(hostdata);
            });
        
            // Recuperation des infos du client
            //
            axios(diagonalbackURL + "/clients/"+ this.clientId,  defaultConfig)
            .then(reponse => {
                this.client = reponse.data;
            })
            .catch(error => this.errorHandler(error));
            //
            // Recuperation des Intervenants du client
            //
            axios(diagonalbackURL + "/clients/"+ this.clientId+"/users",  defaultConfig)
            .then(reponse => {
                var tmpUsers = reponse.data;
                tmpUsers.sort(function(a,b) {
                    return a.name.localeCompare(b.name) || a.firstName.localeCompare(b.firstName)
                })
                this.users = tmpUsers;
                this.calcDummyUserHeight();
            })
            .catch(error => this.errorHandler(error));
            //
            // Recuperation des domaines du client
            //
            axios(diagonalbackURL + "/clients/"+ this.clientId+"/hosts",  defaultConfig)
            .then(reponse => {
                this.hosts = reponse.data;
                this.calcDummyHostHeight();
            })
            .catch(error => this.errorHandler(error));
            //
            // Recuperation des configuration du client
            //
            axios(diagonalbackURL + "/clients/"+ this.clientId+"/settings",  defaultConfig)
            .then(reponse => {
                this.settings = reponse.data;

                //if (this.settings.length > 0 && this.isSuperAdmin()) {
                //   this.$store.dispatch('chooseSetting', this.settings[0]);
                //}
            })
            .catch(error => this.errorHandler(error));
            //
            // Calcul de la taille des dummylines
            //
            this.calcDummyUserHeight();
            this.calcDummyHostHeight();
        },
        methods : {
            isSuperAdmin() {
                return this.$store.state.currentUser.role == RoleEnum.SUPERADMIN.value;
            },
            clickAddUser() {
                this.emitter.emit('showPLForm', {mode:'formUser_new'});
            },
            // Création d'un client.
            //
            createUser(aUserData) {
                console.log("Creation d'un utilisateur : " + aUserData.name + " " + aUserData.firstName)

                const params = JSON.stringify({
                        'name':aUserData.name,
                        'firstName':aUserData.firstName,
                        'mail':aUserData.mail,
                        'note':aUserData.note,
                        'role':aUserData.role,
                    });

                axios.put(diagonalbackURL + "/clients/"+this.clientId+"/users", params, defaultConfig)
                .then(reponse => {
                    this.$router.go();
                })
                .catch(error => {
                    this.errorHandler(error)

                    this.emitter.emit('showPLFormError', {mode:'formUser_error'});
                });

            },
            editUser(newUserData){
                console.log("Modification d'un utilisateur : " + newUserData.name + " " + newUserData.firstName)

                const params = JSON.stringify({
                        'name':newUserData.name,
                        'firstName':newUserData.firstName,
                        'mail':newUserData.mail,
                        'note':newUserData.note,
                        'role':newUserData.role,
                    });

                axios.post(diagonalbackURL + "/users/"+newUserData.id, params, defaultConfig)
                .then(reponse => {
                    this.$router.go();
                })
                .catch(error => this.errorHandler(error));
            },
            removeUser(userToDelete){

                axios.delete(diagonalbackURL + "/users/"+userToDelete.id,  defaultConfig)
                .then(reponse => {
                    this.$router.go();
                })
                .catch(error => this.errorHandler(error));
                
            },
            clickAddHost() {
                this.emitter.emit('showPLForm', {mode: 'formHost_new'});
            },
            createHost(aHostdata) {
                console.log("Creation d'un domaine : " + aHostdata.name)

                const params = JSON.stringify({
                    'name':aHostdata.name,
                    'active':aHostdata.active
                });

                axios.put(diagonalbackURL + "/clients/"+this.clientId+"/hosts", params, defaultConfig)
                .then(reponse => {
                    this.$router.go();
                })
                .catch(error => this.errorHandler(error));

            },
            editHost(aHostdata) {
                console.log("Modification d'un domaine : " + aHostdata.name)

                const params = JSON.stringify({
                    'name':aHostdata.name,
                    'active':aHostdata.active
                });

                axios.post(diagonalbackURL + "/hosts/"+aHostdata.id, params, defaultConfig)
                .then(reponse => {
                    this.$router.go();
                })
                .catch(error => this.errorHandler(error));
            },
            removeHost(toDeleteHost) {
                console.log("Suppression d'un domaine : " + toDeleteHost.name + "/" + toDeleteHost.id)

                axios.delete(diagonalbackURL + "/hosts/"+ toDeleteHost.id,  defaultConfig)
                .then(reponse => {
                    this.$router.go();
                })
                .catch(error => this.errorHandler(error));
            },
            calcDummyUserHeight() {
                var calcHeight = 25;
                if (this.$refs.usersBox != undefined && this.users.length != undefined) {
                    calcHeight = this.$refs.usersBox.scrollHeight - (this.users.length*27);
                }

                this.dummyUserHeight = calcHeight;
            },
            calcDummyHostHeight() {
                var calcHeight = 25;
                if (this.$refs.hostsBox != undefined && this.hosts.length != undefined) {
                    calcHeight = this.$refs.hostsBox.scrollHeight - (this.hosts.length*27);
                }

                this.dummyHostHeight = calcHeight;
            },
        },
        unmounted() {
            // Evenement relatif a la creation/modification/suppresion d'un intervenant
            //
            this.emitter.off('createUser');
            this.emitter.off('editUser');
            this.emitter.off('removeUser');

            // Evenement relatif a la creation/modification/suppresion d'un domaine
            //
            this.emitter.off('createHost');
            this.emitter.off('editHost');
            this.emitter.off('removeHost');
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.component_title {
    color : grey;
}


/* Client Page */

#codeclient {
    float:right;
    margin-top: 17px;
}

.header_line {
    overflow:hidden;
}

.btnDelete {
    position: absolute;
    top:5px;
    right:5px;
}

.btnEdit {
    position: absolute;
    top:5px;
    right:25px;

    color: #0075bb;
}

/* UserTab, header_col + dummyline */

#userTab.pl-list .content {
	overflow-y: auto;
}

#userTab  .col1 {
    width : 100px;
}

#userTab .col2 {
    width: 100px;
    border-right: 1px solid #E6E6E6;
}

#userTab .col3 {
    width: 160px;
    text-align: left;
    padding-left: 8px;
}  

#userTab .col4 {
    text-overflow: ellipsis;
    overflow: hidden;
}


#userTab .header_col.col5 {
    border:none;
}


/* HostTab */


#hostTab .col1 {
    width: 300px;
}

#hostTab .col2 {
    width: 170px;
    border-right-width:1px;
}

#hostTab .col3 {
    width:210px;
    padding-left : 8px;
}

#userTab .dummyline .col2 {
    border-right-color: #0075bb;
}


</style>
